import { render, staticRenderFns } from "./ListDokter.vue?vue&type=template&id=3fd2a265"
import script from "./ListDokter.vue?vue&type=script&lang=js"
export * from "./ListDokter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports